import { SET_ORDER, SET_BOXES, SET_AWARENESS_STATUS } from "./order.types";
import { IOrder } from "../../models/order";
import IBox from "../../models/box";

export interface SetOrderAction {type: typeof SET_ORDER, data:IOrder}
export interface SetBoxesAction {type: typeof SET_BOXES, data:IBox}
export interface SetAllBoxesAgeControlledAction { type: typeof SET_AWARENESS_STATUS, data: boolean; }

export const orderCreator = {
    setOrder: (data:IOrder | null) => ({ type: SET_ORDER, data: data } as SetOrderAction),
    setBoxes: (data:IBox | null) => ({ type: SET_BOXES, data: data } as SetBoxesAction),
    setAllBoxesAgeControlled: (isAgeControlled: boolean) => ({ type: SET_AWARENESS_STATUS, data: isAgeControlled } as SetAllBoxesAgeControlledAction)
};
